let doctorReviews = document.querySelector(".doctorPG__reviewList");

if (doctorReviews) {
	let doctorReviewsCarousel = new Flickity(doctorReviews, {
		cellAlign: "center",
		contain: true,
		prevNextButtons: false,
		pageDots: true,
		watchCSS: true,
	});
}

let doctorReviewVideos = document.querySelectorAll(".doctorPG__reviewPlayBtn");

doctorReviewVideos.forEach((item) => {
	item.addEventListener("click", () => {
		let element = item.closest(".doctorPG__review");
		let video = element.querySelector("video");

		element.classList.add("doctorPG__review--playing");
		video.setAttribute("controls", true);
		video.play();
	});
});
